/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Account } from '../model';
// @ts-ignore
import { AccountConnectionStatusResponse } from '../model';
// @ts-ignore
import { AccountWithAccessTokenAndJob } from '../model';
// @ts-ignore
import { BankSlug } from '../model';
// @ts-ignore
import { PatchAccountRequest } from '../model';
// @ts-ignore
import { V1AccountIdDelete200Response } from '../model';
// @ts-ignore
import { V1AccountsBankSlugPost201Response } from '../model';
// @ts-ignore
import { V1AccountsBankSlugPostRequest } from '../model';
// @ts-ignore
import { V1AccountsTokenIdDelete200Response } from '../model';
/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an account using soft delete (sets deleted_at timestamp)
         * @summary Delete Account
         * @param {number} id Account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v1AccountIdDelete', 'id', id)
            const localVarPath = `/v1/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update account properties such as active status
         * @summary Update Account
         * @param {number} id Account ID
         * @param {PatchAccountRequest} patchAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountIdPatch: async (id: number, patchAccountRequest: PatchAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v1AccountIdPatch', 'id', id)
            // verify required parameter 'patchAccountRequest' is not null or undefined
            assertParamExists('v1AccountIdPatch', 'patchAccountRequest', patchAccountRequest)
            const localVarPath = `/v1/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add accounts and associate them with access_token. 
         * @summary Create Accounts
         * @param {BankSlug} bankSlug 
         * @param {V1AccountsBankSlugPostRequest} v1AccountsBankSlugPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsBankSlugPost: async (bankSlug: BankSlug, v1AccountsBankSlugPostRequest: V1AccountsBankSlugPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankSlug' is not null or undefined
            assertParamExists('v1AccountsBankSlugPost', 'bankSlug', bankSlug)
            // verify required parameter 'v1AccountsBankSlugPostRequest' is not null or undefined
            assertParamExists('v1AccountsBankSlugPost', 'v1AccountsBankSlugPostRequest', v1AccountsBankSlugPostRequest)
            const localVarPath = `/v1/accounts/{bank_slug}`
                .replace(`{${"bank_slug"}}`, encodeURIComponent(String(bankSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1AccountsBankSlugPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the overall connection status of all user accounts and tokens.  This endpoint checks: - Token expiration status (expiring or expired) - Account operation status (transaction fetch failures, etc.)  Returns: - SUCCESS: All connections are normal - EXPIRING: At least one token is expiring soon - EXPIRED: At least one token has expired - FAILURE: At least one account operation has failed - NOT_CONNECTED: No connection exists 
         * @summary Get Account Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsConnectionStatusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/accounts/connection-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all accounts with their access tokens for the current user
         * @summary Get Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete all accounts associated with a specific access token ID and deactivate the token. This operation will: - Set the access token to inactive (active = false) - Update the token\'s expiry date to past time (if applicable) - Soft delete all accounts associated with the token (sets deleted_at timestamp) 
         * @summary Delete Accounts by Token ID
         * @param {number} id Access Token ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsTokenIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v1AccountsTokenIdDelete', 'id', id)
            const localVarPath = `/v1/accounts/token/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an account using soft delete (sets deleted_at timestamp)
         * @summary Delete Account
         * @param {number} id Account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AccountIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update account properties such as active status
         * @summary Update Account
         * @param {number} id Account ID
         * @param {PatchAccountRequest} patchAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountIdPatch(id: number, patchAccountRequest: PatchAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountIdPatch(id, patchAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add accounts and associate them with access_token. 
         * @summary Create Accounts
         * @param {BankSlug} bankSlug 
         * @param {V1AccountsBankSlugPostRequest} v1AccountsBankSlugPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountsBankSlugPost(bankSlug: BankSlug, v1AccountsBankSlugPostRequest: V1AccountsBankSlugPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AccountsBankSlugPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountsBankSlugPost(bankSlug, v1AccountsBankSlugPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the overall connection status of all user accounts and tokens.  This endpoint checks: - Token expiration status (expiring or expired) - Account operation status (transaction fetch failures, etc.)  Returns: - SUCCESS: All connections are normal - EXPIRING: At least one token is expiring soon - EXPIRED: At least one token has expired - FAILURE: At least one account operation has failed - NOT_CONNECTED: No connection exists 
         * @summary Get Account Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountsConnectionStatusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountConnectionStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountsConnectionStatusGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all accounts with their access tokens for the current user
         * @summary Get Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountWithAccessTokenAndJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete all accounts associated with a specific access token ID and deactivate the token. This operation will: - Set the access token to inactive (active = false) - Update the token\'s expiry date to past time (if applicable) - Soft delete all accounts associated with the token (sets deleted_at timestamp) 
         * @summary Delete Accounts by Token ID
         * @param {number} id Access Token ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountsTokenIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AccountsTokenIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountsTokenIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * Delete an account using soft delete (sets deleted_at timestamp)
         * @summary Delete Account
         * @param {AccountsApiV1AccountIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountIdDelete(requestParameters: AccountsApiV1AccountIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<V1AccountIdDelete200Response> {
            return localVarFp.v1AccountIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update account properties such as active status
         * @summary Update Account
         * @param {AccountsApiV1AccountIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountIdPatch(requestParameters: AccountsApiV1AccountIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<Account> {
            return localVarFp.v1AccountIdPatch(requestParameters.id, requestParameters.patchAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add accounts and associate them with access_token. 
         * @summary Create Accounts
         * @param {AccountsApiV1AccountsBankSlugPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsBankSlugPost(requestParameters: AccountsApiV1AccountsBankSlugPostRequest, options?: AxiosRequestConfig): AxiosPromise<V1AccountsBankSlugPost201Response> {
            return localVarFp.v1AccountsBankSlugPost(requestParameters.bankSlug, requestParameters.v1AccountsBankSlugPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the overall connection status of all user accounts and tokens.  This endpoint checks: - Token expiration status (expiring or expired) - Account operation status (transaction fetch failures, etc.)  Returns: - SUCCESS: All connections are normal - EXPIRING: At least one token is expiring soon - EXPIRED: At least one token has expired - FAILURE: At least one account operation has failed - NOT_CONNECTED: No connection exists 
         * @summary Get Account Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsConnectionStatusGet(options?: AxiosRequestConfig): AxiosPromise<AccountConnectionStatusResponse> {
            return localVarFp.v1AccountsConnectionStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all accounts with their access tokens for the current user
         * @summary Get Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsGet(options?: AxiosRequestConfig): AxiosPromise<Array<AccountWithAccessTokenAndJob>> {
            return localVarFp.v1AccountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete all accounts associated with a specific access token ID and deactivate the token. This operation will: - Set the access token to inactive (active = false) - Update the token\'s expiry date to past time (if applicable) - Soft delete all accounts associated with the token (sets deleted_at timestamp) 
         * @summary Delete Accounts by Token ID
         * @param {AccountsApiV1AccountsTokenIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountsTokenIdDelete(requestParameters: AccountsApiV1AccountsTokenIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<V1AccountsTokenIdDelete200Response> {
            return localVarFp.v1AccountsTokenIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1AccountIdDelete operation in AccountsApi.
 * @export
 * @interface AccountsApiV1AccountIdDeleteRequest
 */
export interface AccountsApiV1AccountIdDeleteRequest {
    /**
     * Account ID
     * @type {number}
     * @memberof AccountsApiV1AccountIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for v1AccountIdPatch operation in AccountsApi.
 * @export
 * @interface AccountsApiV1AccountIdPatchRequest
 */
export interface AccountsApiV1AccountIdPatchRequest {
    /**
     * Account ID
     * @type {number}
     * @memberof AccountsApiV1AccountIdPatch
     */
    readonly id: number

    /**
     * 
     * @type {PatchAccountRequest}
     * @memberof AccountsApiV1AccountIdPatch
     */
    readonly patchAccountRequest: PatchAccountRequest
}

/**
 * Request parameters for v1AccountsBankSlugPost operation in AccountsApi.
 * @export
 * @interface AccountsApiV1AccountsBankSlugPostRequest
 */
export interface AccountsApiV1AccountsBankSlugPostRequest {
    /**
     * 
     * @type {BankSlug}
     * @memberof AccountsApiV1AccountsBankSlugPost
     */
    readonly bankSlug: BankSlug

    /**
     * 
     * @type {V1AccountsBankSlugPostRequest}
     * @memberof AccountsApiV1AccountsBankSlugPost
     */
    readonly v1AccountsBankSlugPostRequest: V1AccountsBankSlugPostRequest
}

/**
 * Request parameters for v1AccountsTokenIdDelete operation in AccountsApi.
 * @export
 * @interface AccountsApiV1AccountsTokenIdDeleteRequest
 */
export interface AccountsApiV1AccountsTokenIdDeleteRequest {
    /**
     * Access Token ID
     * @type {number}
     * @memberof AccountsApiV1AccountsTokenIdDelete
     */
    readonly id: number
}

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * Delete an account using soft delete (sets deleted_at timestamp)
     * @summary Delete Account
     * @param {AccountsApiV1AccountIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountIdDelete(requestParameters: AccountsApiV1AccountIdDeleteRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update account properties such as active status
     * @summary Update Account
     * @param {AccountsApiV1AccountIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountIdPatch(requestParameters: AccountsApiV1AccountIdPatchRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountIdPatch(requestParameters.id, requestParameters.patchAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add accounts and associate them with access_token. 
     * @summary Create Accounts
     * @param {AccountsApiV1AccountsBankSlugPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountsBankSlugPost(requestParameters: AccountsApiV1AccountsBankSlugPostRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountsBankSlugPost(requestParameters.bankSlug, requestParameters.v1AccountsBankSlugPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the overall connection status of all user accounts and tokens.  This endpoint checks: - Token expiration status (expiring or expired) - Account operation status (transaction fetch failures, etc.)  Returns: - SUCCESS: All connections are normal - EXPIRING: At least one token is expiring soon - EXPIRED: At least one token has expired - FAILURE: At least one account operation has failed - NOT_CONNECTED: No connection exists 
     * @summary Get Account Connection Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountsConnectionStatusGet(options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountsConnectionStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all accounts with their access tokens for the current user
     * @summary Get Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountsGet(options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete all accounts associated with a specific access token ID and deactivate the token. This operation will: - Set the access token to inactive (active = false) - Update the token\'s expiry date to past time (if applicable) - Soft delete all accounts associated with the token (sets deleted_at timestamp) 
     * @summary Delete Accounts by Token ID
     * @param {AccountsApiV1AccountsTokenIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public v1AccountsTokenIdDelete(requestParameters: AccountsApiV1AccountsTokenIdDeleteRequest, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).v1AccountsTokenIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
